<template>
	<v-navigation-drawer
		v-model="open"
		:clipped="!companyLogo"
		fixed
		app
		:right="right"
		:width="175"
	>

		<v-list-item v-if="companyLogo">
			<v-list-item-content>
				<v-list-item-title class="title">
					<v-img :src="companyLogo"/>
				</v-list-item-title>
			</v-list-item-content>
		</v-list-item>
		<v-divider></v-divider>


		<v-list dense>
			<v-list-item v-for="route in routes" :key="route.name" :to="route">
				<v-list-item-action v-if="route.icon">
					<v-icon>{{route.icon}}</v-icon>
				</v-list-item-action>
				<v-list-item-content>
					<v-list-item-title>{{route.title}}</v-list-item-title>
				</v-list-item-content>
			</v-list-item>
			<v-list-item @click="doLogout">
				<v-list-item-action>
					<v-icon>logout</v-icon>
				</v-list-item-action>
				<v-list-item-content>
					<v-list-item-title>{{$t('attributes.logout')}}</v-list-item-title>
				</v-list-item-content>
			</v-list-item>
		</v-list>

		<v-footer
			app
		>
			<span class="blue--text">CADnet &copy; 2019</span>
		</v-footer>
	</v-navigation-drawer>
</template>

<script>
	import {types as AuthTypes} from "src/store/modules/Auth.module";
	import {isRtl} from "src/lang/";

	export default {
		name: "navigation-drawer",
		props: {
			value: {},
			routes: {
				type: Array,
				default: () => []
			},

		},
		components: {},
		data () {
			return {
				open: true,
				right: true
			};
		},
		computed: {
			config() {
				return this.$store.state.ConfigModule;
			},
			companyLogo() {
				return this.config.app.logo;
			},
		},
		created () {
			this.right = isRtl();
		},
		methods: {
			doLogout () {
				this.$store.dispatch(AuthTypes.LOGOUT).then(() => {
					location.reload();
				});
			}
		},
		watch: {
			value: {
				immediate: true,
				handler () {
					this.open = this.value;
				}
			}

		}

	};
</script>

<style scoped>

</style>
